export default {
    button: {
        // icon: {
        //     class: 'text-primary',
        //     title: '[[[Test]]]'
        // },
        // text: {
        //     class: 'me-auto'
        // },
        // badge: {
        //     class: 'ms-1',
        //     content: '<i class="fa-solid fa-star-of-life fa-xs text-info"></i>',
        //     title: '[[[Kontrolka dostępna publicznie]]]'
        // }
    }
};
